export default __webpack_public_path__ + "static/our-goals@2x-0e23b0fb2d5b7f7f8323567b9349a302.png";